// ABOUTME: Decides whether the logged-in relation may enter product dimensions and weight.
// ABOUTME: Reads the resolved relation settings, where the API already applied the warehouse-wide switch.

export const relationCanEditProductDimensions = (relationSettings) =>
    relationSettings?.find(setting => setting.key === "relation_edit_product_dimensions")?.value === "true";
